<template>
  <div :class="'object' + (' -' + type)" v-hide="{ hide: !!object.removed }" @hideComplete="hideComplete">
    <div class="object__heading">
      <div class="object__label">
        {{ object.name }}
      </div>
      <div class="object__badges" v-if="hasSourceDetails || object.pertinence">
        <TrainingRncpSourceDetailsComponent :object="object" @showDetails="showDetails" />
        <br v-if="hasSourceDetails && object.pertinence" />
        <div v-if="object.pertinence" class="object__sources" :class="{ 'mt-2': hasSourceDetails }">
          {{ $t("training.rncp.badge.confidence") }} :
          <span class="badge bg-light-info" v-if="object.pertinence">{{ object.pertinence }}%</span>
        </div>
      </div>
    </div>
    <div class="object__actions">
      <div class="object__field">
        <FormFieldComponent :model="selectModel" @update="updateSelectedCategory" />
      </div>
      <div class="object__buttons">
        <button
          class="btn-icon me-2 ms-0 ms-md-3 text-success btnAdd"
          @click="add"
          v-tooltip="{
            title: stringManager().globalTranslation('accept', type, 'studea_manager', 1, true),
          }"
        >
          <FontAwesomeIcon icon="fa-solid fa-check" />
        </button>
        <button
          class="btn-icon text-danger btnRemove"
          @click="remove"
          v-tooltip="{
            title: stringManager().globalTranslation('decline', type, 'studea_manager', 1, true),
          }"
        >
          <FontAwesomeIcon icon="fa-solid fa-xmark" />
        </button>
      </div>
    </div>
    <BlockLoader :loading="isLoading || loading" size="small" />
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import FormFieldComponent from "@/components/form/FormFieldComponent.vue";
import { trainingManager } from "@/services/training/training-manager";
import BlockLoader from "@/components/blocks/BlockLoader.vue";
import { stringManager } from "@/services/utilities/string-manager";
import { trainingSkillConstante } from "@/constantes/trainingSkill";
import TrainingRncpSourceDetailsComponent from "@/components/training/rncp/TrainingRncpSourceDetailsComponent.vue";

export default {
  name: "TrainingSkillSuggestionComponent",
  components: { TrainingRncpSourceDetailsComponent, BlockLoader, FormFieldComponent, FontAwesomeIcon },
  emits: ["decline", "accept", "hideComplete", "showDetails"],
  props: {
    category: {
      type: Object,
      required: true,
    },
    object: {
      type: Object,
      required: true,
    },
    targetChoices: {
      type: Array,
      required: true,
    },
    type: {
      type: String,
      required: true,
      validator: function (value) {
        return [trainingSkillConstante.OBJECT_TYPE_SKILL, trainingSkillConstante.OBJECT_TYPE_MISSION].includes(value);
      },
    },
  },
  data() {
    return {
      loading: false,
      selectedCategory: null,
      selectModel: {
        vars: {
          block_prefixes: ["", "choice"],
          expandable: false,
          name: "target-" + this.object.id,
          id: "target-" + this.object.id,
          attr: {},
          row_attr: {
            class: "m-0 flex-grow-1 choice-list-top w-100",
          },
          required: true,
          choices: this.targetChoices,
          value: null,
        },
      },
    };
  },
  computed: {
    isLoading() {
      return this.object.loading;
    },

    hasSourceDetails() {
      return this.object.sourceDetails && Object.keys(this.object.sourceDetails);
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    stringManager() {
      return stringManager;
    },
    init() {
      this.setCurrentToTargetValue();
    },

    updateSelectedCategory(payload) {
      this.selectedCategory = payload.value;
    },

    setCurrentToTargetValue() {
      this.selectModel.vars.value = this.targetChoices.find((choice) => choice.data === this.category.id);
      this.selectedCategory = this.category.id;
    },

    add() {
      this.$emit("accept", {
        object: this.object,
        type: this.type,
        targetCategoryId: this.selectedCategory,
        baseCategoryId: this.category.id,
      });
    },

    async remove() {
      this.loading = true;
      const done = await trainingManager.remove(this.object.id, this.$route.params.trainingId, this.type, this.type);
      if (done && done.success) {
        this.$emit("decline", { object: this.object, type: this.type });
      }
      this.loading = false;
    },

    hideComplete() {
      this.$emit("hideComplete", { object: this.object, type: this.type });
    },

    showDetails() {
      this.$emit("showDetails", { object: this.object, type: this.type });
    },
  },
};
</script>

<style lang="scss" scoped>
.object {
  background: $white;
  color: var(--primary-color);
  padding: 15px 20px 5px 20px;
  border-radius: $radius;
  border-left: 4px solid $ia-color;
  display: flex;
  align-items: center;
  position: relative;
  justify-content: space-between;
  flex-wrap: wrap;

  @include dark-theme {
    background: $dark;
    color: $white;
  }

  @include up-to-md {
    padding: 15px 10px 5px 10px;
  }

  &__heading {
    margin-bottom: 10px;
    margin-right: 10px;
    max-width: 370px;
  }
  &__code {
    font-weight: 700;
  }

  &__actions {
    display: flex;
    align-items: center;
    justify-content: space-between;
    max-width: 350px;
    min-width: 350px;

    @include up-to-md {
      max-width: 225px;
      min-width: 225px;
    }
  }

  &__field {
    width: calc(100% - 68px);
  }

  &__buttons {
    display: flex;
    align-items: center;
  }

  &__badges {
    margin-top: 8px;
    .badge + .badge {
      margin-left: 5px;
    }
  }
}

.object + .object {
  margin-top: 20px;
}
</style>
